import { useEffect } from 'react';
import AOS from 'aos';

const Hero = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section id="hero" className="d-flex align-items-center justify-content-center">
      <div className="container" data-aos="fade-up">
        <img src="assets/img/logo.png" alt="Logo" height="200" />
        <div className="row justify-content-center" data-aos="fade-up" data-aos-delay="150">
          <div className="col-xl-9 col-lg-9">
            <h1>COIL MANUFACTURER</h1>
            <h2>Our coil manufacturing process ensures that each product perfectly meets the client's requirements while maintaining the highest quality standards.</h2>
          </div>
        </div>

        <div className="row gy-4 mt-5 justify-content-center" data-aos="zoom-in" data-aos-delay="250">
          <div className="col-xl-2 col-md-4">
            <div className="icon-box">
              <h3><a href="#hero">SMPS Transformer Coils</a></h3>
            </div>
          </div>
          <div className="col-xl-2 col-md-4">
            <div className="icon-box">
              <h3><a href="#hero">Switch Gear Closing Tripping Coils</a></h3>
            </div>
          </div>
          <div className="col-xl-2 col-md-4">
            <div className="icon-box">
              <h3><a href="#hero">Relay Coils: Wire and Tape Wound Coils</a></h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
